const BLOCKED_TAGS = ["script", "style", "iframe", "object", "embed", "link", "meta"]

const DANGEROUS_ATTR_PREFIX = "on"
const DANGEROUS_URL_PATTERN = /^\s*javascript:/i

export function sanitizeHtml(unsafeHtml) {
    const template = document.createElement("template")
    template.innerHTML = String(unsafeHtml ?? "")

    const blockedSelector = BLOCKED_TAGS.join(",")
    template.content.querySelectorAll(blockedSelector).forEach((node) => node.remove())

    template.content.querySelectorAll("*").forEach((element) => {
        Array.from(element.attributes).forEach((attribute) => {
            const attrName = attribute.name.toLowerCase()
            const attrValue = attribute.value

            if (attrName.startsWith(DANGEROUS_ATTR_PREFIX)) {
                element.removeAttribute(attribute.name)
                return
            }

            if ((attrName === "href" || attrName === "src") && DANGEROUS_URL_PATTERN.test(attrValue)) {
                element.removeAttribute(attribute.name)
            }
        })
    })

    return template.innerHTML
}
